import React, { useState, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Package, Truck, ShoppingBag, Grid, Power, Wrench, Bot } from 'lucide-react';

// Lot 7 — FUSION CATALOGUE : un SEUL écran regroupe les 7 anciens écrans produits
// (prestations, location, vente, packs, disponibilités, état matériel, catalogue & IA).
// Chaque onglet monte l'écran existant TEL QUEL (aucune logique dupliquée, aucune donnée
// perdue) ; seul l'onglet actif est monté (chargement à la demande). Les anciennes routes
// redirigent ici avec ?tab=… (migration progressive, réversible).
import AdminGestionProduits from './AdminGestionProduits';
import AdminCatalogueLocation from './AdminCatalogueLocation';
import AdminCatalogueVente from './AdminCatalogueVente';
import AdminPacks from './AdminPacks';
import AdminDispoProduits from './AdminDispoProduits';
import AdminEtatMateriel from './AdminEtatMateriel';
import AdminCatalogue from './AdminCatalogue';

const TABS = [
  { key: 'prestations', label: 'Prestations', icon: <Package size={14} />, Comp: AdminGestionProduits },
  { key: 'location', label: 'Matériel location', icon: <Truck size={14} />, Comp: AdminCatalogueLocation },
  { key: 'vente', label: 'Produits à vendre', icon: <ShoppingBag size={14} />, Comp: AdminCatalogueVente },
  { key: 'packs', label: 'Packs', icon: <Grid size={14} />, Comp: AdminPacks },
  { key: 'dispo', label: 'Disponibilités', icon: <Power size={14} />, Comp: AdminDispoProduits },
  { key: 'etat', label: 'État du matériel', icon: <Wrench size={14} />, Comp: AdminEtatMateriel },
  { key: 'ia', label: 'Catalogue & IA', icon: <Bot size={14} />, Comp: AdminCatalogue },
];

export default function AdminCatalogueUnifie() {
  const [params, setParams] = useSearchParams();
  const initial = TABS.find((t) => t.key === params.get('tab'))?.key || 'prestations';
  const [tab, setTab] = useState(initial);

  const Active = useMemo(() => TABS.find((t) => t.key === tab)?.Comp || TABS[0].Comp, [tab]);

  const select = (k) => {
    setTab(k);
    setParams({ tab: k }, { replace: true });
  };

  return (
    <div data-testid="catalogue-unifie">
      <div style={{ marginBottom: 16 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--admin-text)', margin: 0, fontFamily: 'var(--admin-font-display)' }}>
          Catalogue
        </h1>
        <p style={{ fontSize: 12.5, color: 'var(--admin-faint)', margin: '4px 0 0' }}>
          Prestations, matériel, produits à vendre, packs, disponibilités et état — regroupés en un seul écran.
        </p>
      </div>

      {/* Onglets — rangée horizontale unique, scrollable */}
      <div
        style={{
          display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 10, marginBottom: 18,
          borderBottom: '1px solid var(--admin-border-soft)',
        }}
        data-testid="catalogue-tabs"
      >
        {TABS.map((t) => {
          const active = t.key === tab;
          return (
            <button
              key={t.key}
              onClick={() => select(t.key)}
              data-testid={`catalogue-tab-${t.key}`}
              style={{
                display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0,
                padding: '8px 14px', borderRadius: 10, cursor: 'pointer',
                border: `1px solid ${active ? 'var(--admin-teal)' : 'var(--admin-border)'}`,
                background: active ? 'var(--admin-teal-dim)' : 'var(--admin-surface)',
                color: active ? 'var(--admin-teal)' : 'var(--admin-muted)',
                fontSize: 13, fontWeight: active ? 600 : 500, whiteSpace: 'nowrap',
              }}
            >
              {t.icon} {t.label}
            </button>
          );
        })}
      </div>

      {/* Écran de l'onglet actif (monté à la demande) */}
      <div key={tab}>
        <Active />
      </div>
    </div>
  );
}
